import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { markActivity, lastActivity, IDLE_LIMIT_MS } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const WARN_MS = 60 * 1000;
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel"];

export const IdleWatcher = ({ onTimeout }) => {
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    let lastMark = 0;
    let fired = false;
    const onActivity = () => {
      if (Date.now() - lastMark > 5000) { lastMark = Date.now(); markActivity(); }
    };
    markActivity();
    EVENTS.forEach((e) => window.addEventListener(e, onActivity, { passive: true }));
    const beat = setInterval(() => {
      if (Date.now() - lastActivity() < 60 * 1000) { api.post("/auth/heartbeat").catch(() => {}); }
    }, 60 * 1000);
    const tick = setInterval(() => {
      const left = IDLE_LIMIT_MS - (Date.now() - lastActivity());
      if (left <= 0) {
        if (fired) { return; }
        fired = true;
        toast.info("You were signed out after 30 minutes of inactivity");
        onTimeout();
      } else {
        setRemaining(left <= WARN_MS ? left : null);
      }
    }, 1000);
    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, onActivity));
      clearInterval(beat);
      clearInterval(tick);
    };
  }, [onTimeout]);

  const stay = () => {
    markActivity();
    setRemaining(null);
    api.post("/auth/heartbeat").catch(() => {});
  };

  return (
    <AlertDialog open={remaining !== null}>
      <AlertDialogContent data-testid="idle-warning-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Are you still there?</AlertDialogTitle>
          <AlertDialogDescription data-testid="idle-warning-countdown">
            For your security you will be signed out in {Math.ceil((remaining || 0) / 1000)} seconds.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="idle-sign-out-btn" onClick={onTimeout}>Sign out</AlertDialogCancel>
          <AlertDialogAction data-testid="idle-stay-signed-in-btn" onClick={stay}>Stay signed in</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
